/**
 * Mở chứng từ đã lưu trên máy chủ.
 *
 * #56022/#56024: trước đây hai màn checker gọi thẳng `window.open(doc.documentPath)`.
 * Nhưng `documentPath` backend trả về là KHOÁ LƯU TRỮ nội bộ (ví dụ
 * `javis-biz/2026/09/abc.pdf`), không phải địa chỉ web. Trình duyệt ghép chuỗi đó vào
 * tên miền của trang, bộ định tuyến không khớp nên người dùng rơi vào trang 404 —
 * không hiểu vì sao và mất luôn màn đang xem.
 *
 * Nghiệp vụ chuyển tiền quốc tế hiện CHƯA có API tải chứng từ đã lưu (đã rà
 * `internationalTransferAPI`: chỉ có hàm bổ sung chứng từ, không có hàm tải về; luồng
 * người tạo lệnh tải được là nhờ tệp còn nằm trong bộ nhớ trình duyệt dưới dạng base64).
 * Vì vậy hàm này chỉ làm được hai việc, và đó là đúng giới hạn của frontend:
 *   - `documentPath` là địa chỉ web thật  -> mở bình thường;
 *   - ngược lại -> KHÔNG điều hướng đi đâu, báo cho người dùng biết chứng từ chưa tải
 *     được thay vì ném họ sang trang 404.
 *
 * Khi backend bổ sung API trả địa chỉ tải có thời hạn, thay phần `else` bằng lời gọi đó.
 */
import { notifications } from "@mantine/notifications";
import i18n from "i18n/i18n";

/** Địa chỉ mở được trực tiếp: http(s), blob hoặc data. */
const isOpenableUrl = (path: string): boolean =>
  /^(https?:)?\/\//i.test(path) || /^(blob|data):/i.test(path);

export const openStoredDocument = (documentPath?: string | null): void => {
  const path = String(documentPath ?? "").trim();
  if (!path) return;

  if (isOpenableUrl(path)) {
    window.open(path, "_blank", "noopener,noreferrer");
    return;
  }

  notifications.show({
    title: i18n.t("NOTICE"),
    message: i18n.t("DOCUMENT_DOWNLOAD_NOT_AVAILABLE"),
    color: "orange",
  });
};

export default openStoredDocument;
